import { render, staticRenderFns } from "./ScrollTable.vue?vue&type=template&id=60cab398&"
import script from "./ScrollTable.vue?vue&type=script&lang=js&"
export * from "./ScrollTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports